import { Route, Switch, useLocation } from 'react-router-dom';
import { Front, Layout } from './components/Layout';
import { Navigation } from './features/navigation/Navigation';
import { TopPanel } from './features/top/TopPanel';
import { DashboardContainer } from './features/dashboard/DashboardContainer';
import { ActionFormContainer } from './features/forms/ActionFormContainer';
import { LoginContainer } from './features/login/LoginContainer';
import { NotificationContainer } from './features/notifications/NotificationContainer';
import { LogoutPage } from './features/login/Logout';
import { PrivateRoute } from './features/login/PrivateRoute';
import { HelpPanelContainer } from './features/help/HelpPanelContainer';
import { ShcContainer } from './features/shc/ShcContainer';
import { PageContentContainer } from './features/content/PageContentContainer';
import { DetailsContainer } from './features/details/DetailsContainer';
import { Page404 } from './components/Page404';
import { DownloadsContainer } from './features/downloads/DownloadsContainer';
import { useKeycloak } from '@react-keycloak/web';
import { CookiesConsent } from './features/user/CookiesConsent';

const App = () => {
    const location = useLocation().pathname;
    const { keycloak, initialized } = useKeycloak();

    return (
        <Layout id="sp-app-layout">
            {initialized
                ? <>
                    <Navigation />
                    <Layout direction="column">
                        {keycloak.authenticated && location !== "/login" && location !== "/logout" &&  <TopPanel pathname={location} />}
                        <Switch>
                            <Route path="/login" component={LoginContainer}/>
                            <Route path="/logout" component={LogoutPage} />
                            <PrivateRoute exact path={["/", "/dashboard", "/audit", "/services"]} component={DashboardContainer} />
                            <PrivateRoute exact path={["/organisations/:org/:tab", "/audit/:tab", "/contracts/all", "/contracts/:selected/:tab", "/services/:tab/uploads", "/:tab"]} component={PageContentContainer} />
                            <PrivateRoute exact path={["/organisations/:org", "/organisations/:org/:tab/:selected", "/audit/:tab/:selected", "/services/:tab/uploads/:selected", "/:tab/:selected"]} component={DetailsContainer} />
                            <PrivateRoute exact path={["/services/shc/nodes/:node?", "/services/shc/nodes/:node?/files/:file?"]} component={ShcContainer} />
                            <PrivateRoute path="*" component={Page404} />
                        </Switch>
                        {location !== "/login" && location !== "/logout" &&
                        <Front id="sp-front-panel">
                            <NotificationContainer />
                            <CookiesConsent />
                        </Front>}
                        <ActionFormContainer />
                        <HelpPanelContainer />
                        <DownloadsContainer />
                    </Layout>
                </>
                : null}
        </Layout>
    );
}

export default App;
